import React, { useState } from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className="w-full bg-white shadow-lg fixed top-0 left-0 z-50 border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-6 py-5 flex items-center justify-between">
        
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 group">
          <img src="/logo.png" alt="PAK School Logo" className="h-10 w-auto transition-transform duration-300 group-hover:scale-105" />
          
        </Link>

        {/* Desktop Menu */}
        <div
          className={`md:flex md:items-center md:gap-8 absolute md:static left-0 w-full md:w-auto bg-white transition-all duration-500 ease-in-out ${
            menuOpen
              ? "top-16 opacity-100 shadow-lg md:shadow-none"
              : "top-[-500px] opacity-0 md:opacity-100"
          }`}
        >
          {[
            { to: "/", label: "Home" },
            { to: "/about", label: "About Us" },
            { to: "/gallery", label: "Gallery" },
            { to: "/admission", label: "Admission" },
            { to: "/academics", label: "Academics" },
            { to: "/contact", label: "Contact Us" },
          ].map((item) => (
            <Link
              key={item.to}
              to={item.to}
              onClick={closeMenu}
              className="relative block py-3 px-6 md:p-0 text-gray-800 font-bold group hover:text-blue-600 transition-all duration-300 text-sm md:text-base tracking-wider uppercase text-sm md:text-sm"
            >
              {item.label}
              <span className="absolute left-0 bottom-0 w-0 h-[3px] bg-gradient-to-r from-blue-600 to-red-500 transition-all duration-300 group-hover:w-full rounded-full"></span>
            </Link>
          ))}
        </div>

        {/* Button (optional) */}
        <Link
          to="/admission"
          className="hidden md:inline-block bg-gradient-to-r from-blue-600 to-blue-700 text-white px-6 py-2.5 rounded-full shadow-lg hover:shadow-xl hover:from-blue-700 hover:to-blue-800 transition-all duration-300 font-bold text-sm tracking-wider uppercase"
        >
          Apply Now
        </Link>

        {/* Hamburger Menu */}
        <div
          onClick={toggleMenu}
          className="md:hidden flex flex-col gap-[5px] cursor-pointer"
        >
          <span
            className={`w-6 h-[2px] bg-gray-800 transition-all duration-300 ${
              menuOpen ? "rotate-45 translate-y-[6px]" : ""
            }`}
          ></span>
          <span
            className={`w-6 h-[2px] bg-gray-800 transition-all duration-300 ${
              menuOpen ? "opacity-0" : ""
            }`}
          ></span>
          <span
            className={`w-6 h-[2px] bg-gray-800 transition-all duration-300 ${
              menuOpen ? "-rotate-45 -translate-y-[6px]" : ""
            }`}
          ></span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
